import { createTheme } from "@material-ui/core/styles";

const fontSize75 = "0.75rem !important";
const fontSize875 = "0.875rem !important";

const FranchiseTheme = createTheme({
  palette: {},
  overrides: {
    MuiFormControlLabel: {
      label: {
        fontSize: fontSize875,
        color: "rgba(0, 0, 0, 0.87) !important"
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: "7px 14px",
      },
      multiline: {
        padding: "10px 14px",
      },
    },
    MuiInputBase: {
      input: {
        fontSize: fontSize875,
      },
    },
    MuiCheckbox: {
      root: {
        padding: "6px"
      }
    }
  },
});

export default FranchiseTheme;
